module.exports = __webpack_public_path__ + "img/ye.54afdda4.svg";